import type { MouseEvent } from "react";
import { LeftAlignIcon } from "@/icons/widget-menu";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";

interface UseAlignButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useAlignButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseAlignButtonProps): MenuOptionResult {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "align" ? null : { name: "align", anchor: button },
        );
    };

    const isActive = activeSubMenu?.name === "align";

    return {
        content: <LeftAlignIcon />,
        handleClick,
        isActive,
    };
}
